document.addEventListener('DOMContentLoaded', function () {
    const tabsContainers = document.querySelectorAll('[data-tabs]');

    tabsContainers.forEach((container) => {
      const buttons = container.querySelectorAll('[data-tab-button]');
      const contents = container.querySelectorAll('[data-tab-content]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const tabId = button.getAttribute('data-tab-button');

          buttons.forEach((btn) => btn.classList.remove('active'));
          button.classList.add('active');

          contents.forEach((content) => content.classList.remove('active'));
          container.querySelector(`[data-tab-content="${tabId}"]`).classList.add('active');
        });
      });
    });
  });


  // document.addEventListener('DOMContentLoaded', function () {
  //   const tabsContainers = document.querySelectorAll('[data-tabs]');
  
  //   tabsContainers.forEach((container) => {
  //     const buttons = container.querySelectorAll('[data-tab-button]');
  //     const contents = container.querySelectorAll('[data-tab-content]');
  //     const tabsNav = container.querySelector('.gbc-tabs-nav');
  
  //     // Check if the tabsNav is scrollable
  //     if (tabsNav && tabsNav.scrollWidth > tabsNav.clientWidth) {
  //       tabsNav.classList.add('gbc-tabs-nav-scroll');
  //       tabsNav.classList.add('active');
  
  //       // Add scroll event listener
  //       tabsNav.addEventListener('scroll', () => {
  //         if (tabsNav.scrollLeft + tabsNav.clientWidth >= tabsNav.scrollWidth) {
  //           // If scrolled to the end, remove 'active' class
  //           tabsNav.classList.remove('active');
  //         } else {
  //           // If not at the end, add 'active' class
  //           tabsNav.classList.add('active');
  //         }
  //       });
  //     }
  
  //     buttons.forEach((button) => {
  //       button.addEventListener('click', () => {
  //         const tabId = button.getAttribute('data-tab-button');
  
  //         buttons.forEach((btn) => btn.classList.remove('active'));
  //         button.classList.add('active');
  
  //         contents.forEach((content) => content.classList.remove('active'));
  //         container.querySelector(`[data-tab-content="${tabId}"]`).classList.add('active');
  //       });
  //     });
  //   });
  // });